import React from "react";
import { connect } from "react-redux";
import { changeMenuInicio } from "../Planes/actions"; 
import { changeTabIndex } from "../../Header/actions";

class menuItem extends React.Component {
  
  getEstadoArray = (estado) => {
    switch (estado) {
      case 1: return 1;
      case 2: return 3;
      case 3: return 5;
      case 4: return 7;
      default: return 0;
    }
  }

  createContent = (id) => {
    let mensaje = "";
    let titulo = "";
    switch (id) {
      case 1:
        titulo = <div><h3>Sensibilización</h3><h3>Plazo recomendado: 1 semana</h3></div>;
        mensaje = <div><p style={{ fontSize: 15 }}>El éxito del plan de movilidad se basa en la participación activa tanto de la administración como de los trabajadores.</p><p style={{ fontSize: 15 }}> Para lograr eso, debemos visibilizar la problemática que pretendemos abordar -riesgos presentes en la vía pública- e invitarlos a ser parte de su solución.</p></div>;
        break;
      case 2:
        titulo = <div><h3>Diagnóstico</h3><h3>Plazo recomendado: 2 semanas</h3></div>;
        mensaje = <div><p style={{ fontSize: 15 }}>Las decisiones de movilidad deben ser analizadas conociendo su contexto. Las formas de trasladarse de un lugar a otro dependerán de las alternativas de transporte disponible, el horario del viaje, entre otros.</p><p style={{ fontSize: 15 }}>Para conocer este contexto, deberás realizar un diagnóstico de movilidad para tu centro de trabajo.</p></div>;
        break;
      case 3:
        titulo = <div><h3>Plan de acción</h3><h3>Plazo recomendado: 1 semana</h3></div>;
        mensaje = <div><p style={{ fontSize: 15 }}>Te presentaremos una propuesta de medidas a implementar en el centro de trabajo considerando los usuarios viales y riesgos identificados durante la etapa de diagnóstico.</p><p style={{ fontSize: 15 }}>Luego, el centro de trabajo definirá las acciones y plazos para llevar a cabo la ejecución de estas medidas.</p></div>;
        break;
      case 4:
        titulo = <div><h3>Ejecución y seguimiento</h3><h3>Plazo recomendado: 12 meses</h3></div>;
        mensaje = <div><p style={{ fontSize: 15 }}>Ejecución de las acciones definidas en los plazos comprometidos. Se podrá hacer seguimiento del avance de las acciones a través de la plataforma.</p></div>;
        break;
      default:
    }
    return (<div>{titulo}{mensaje}</div>);
  }

  render() {
    return (
      <div className="container-fluid">
            <div className="text-center pt-10">
              <h3 className="PM-section-title">Lo que debes saber para implementar tu plan con éxito</h3>
            </div>
            <ul className="nav PM-nav-pills PM-nav-plan justify-content-center" id="pills-tab" role="tablist">
              <li className="PM-nav-item-plan" onClick={() => this.props.dispatch(changeMenuInicio(0))}>
                <span
                  className= {this.props.inicioMenuPosition === 0? "PM-nav-link-plan active": "PM-nav-link-plan"}
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#etapa-one"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >E1
                </span>
              </li>
              <li className="PM-nav-item-plan" onClick={() => this.props.dispatch(changeMenuInicio(1))}>
                <span
                  className= {this.props.inicioMenuPosition === 1? "PM-nav-link-plan active": "PM-nav-link-plan"}
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#etapa-one"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >E2
                </span>
              </li>
              <li className="PM-nav-item-plan" onClick={() => this.props.dispatch(changeMenuInicio(2))}>
                <span
                  className= {this.props.inicioMenuPosition === 2? "PM-nav-link-plan active": "PM-nav-link-plan"}
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#etapa-one"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >E3
                </span>
              </li>
              <li className="PM-nav-item-plan" onClick={() => this.props.dispatch(changeMenuInicio(3))}>
                <span
                  className= {this.props.inicioMenuPosition === 3? "PM-nav-link-plan active": "PM-nav-link-plan"}
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#etapa-one"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >E4
                </span>
              </li>
            </ul>
            <div className="tab-content pt-2 pl-1 " id="pills-tabContent">
              <div className="tab-pane fade show active PM-plan-borde-spacing" id="etapa-one" role="tabpanel" aria-labelledby="pills-home-tab">
                <br /><br />
                <div className="row">
                  <div className="col-md-6 video-capsula pt-10 plr-20">
                    {
                      this.props.listaContenidos.length > 0 ?
                        <iframe
                          title="myform"
                          width="100%"
                          height="400"
                          src={this.props.listaContenidos[this.getEstadoArray(this.props.inicioMenuPosition+1)].tblContenidosArchivo[0].link}
                          frameBorder="0"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        >
                        </iframe>
                        :
                        null
                    }
                  </div>
                  <div className="col-md-6 PM-cuadro-3 pt-10 plr-20">
                    {this.createContent(this.props.inicioMenuPosition+1)}
                    <button
                      style={{ marginTop: 10 }}
                      type="button"
                      className="btn PM-dx-button-plan PM-dx-button-plan-40"
                      // disabled={!(this.props.ultimoEstadoProceso-1 === this.props.inicioMenuPosition) || this.props.sucursalId === ""}
                      onClick={() => { this.props.dispatch(changeTabIndex(1, 1)); }}
                    > Ir a la etapa
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
    );
  }
}

const mapStateToProps = (state) => ({
  inicioMenuPosition: state.planMovilidad.inicioMenuPosition,
  listaContenidos: state.planMovilidad.listaContenidos,
  // ultimoEstadoProceso: state.planMovilidad.ultimoEstadoProceso,
  sucursalId: state.global.sucursalId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(menuItem);
